"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DollarSign = exports.CurrencyContainer = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _mixins = require("../../styles/mixins");
var _HBInput = _interopRequireDefault(require("../HBInput/HBInput"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBInput2 = require("../HBInput/HBInput.styles");
var _variables = require("../HBTextField/variables");
var _HBCurrency = _interopRequireDefault(require("../HBCurrency/HBCurrency"));
var _animations = require("../../styles/animations");
var _HBTextField = require("../HBTextField/HBTextField.styles");
var _HBMoneyInput = require("../HBMoneyInput/HBMoneyInput.utils");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _input = require("../../utils/input.utils");
var _templateObject, _templateObject2;
var _excluded = ["className", "size", "value", "onBlur", "id", "name", "testIdName", "testId", "isHoverable", "onChange", "placeholder", "inputMode", "isDisabled", "currency", "onPostFocus", "type", "inputRef", "minFractionDigits"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBMoneyInput = function HBMoneyInput(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    value = _ref.value,
    onBlur = _ref.onBlur,
    id = _ref.id,
    name = _ref.name,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    isHoverable = _ref.isHoverable,
    _onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    _ref$inputMode = _ref.inputMode,
    inputMode = _ref$inputMode === void 0 ? 'decimal' : _ref$inputMode,
    isDisabled = _ref.isDisabled,
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'USD' : _ref$currency,
    onPostFocus = _ref.onPostFocus,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'number' : _ref$type,
    externalRef = _ref.inputRef,
    minFractionDigits = _ref.minFractionDigits,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var baseProps = _objectSpread({
    id: id,
    name: name,
    className: className,
    size: size,
    value: value,
    onBlur: onBlur,
    placeholder: placeholder
  }, rest);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var _inputRef = (0, _react.useRef)(null);
  var inputRef = externalRef || _inputRef;
  var handleFocusIn = (0, _react.useCallback)(function (e) {
    if (!isDisabled) {
      setIsEditing(true);
      onPostFocus === null || onPostFocus === void 0 || onPostFocus(e);
    }
  }, [isDisabled, onPostFocus]);
  var handleBlur = function handleBlur(ev) {
    setIsEditing(false);
    if (onBlur) {
      onBlur(ev);
    }
  };
  (0, _react.useEffect)(function () {
    if (isEditing && 'current' in inputRef) {
      inputRef.current.focus();
    }
  }, [inputRef, isEditing]);
  var isFalseyNotZero = (0, _HBMoneyInput.falseNotZero)(value);

  // if supplied with placeholder, show it. if not, display empty string if value is null, or 0 if empty string.
  var inputPlaceholder = placeholder || (isFalseyNotZero ? '' : '0');
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id || name,
    suffix: 'money-input',
    componentName: 'HBMoneyInput'
  });

  // since this bug in safari:
  // https://stackoverflow.com/questions/76645238/firefox-or-safari-javascript-parses-an-input-field-type-number-incorrectly
  // then to bypass it in mobile app we allow padding "tel" input. JIRA: HON-19808
  var inputType = inputMode === 'decimal' && type !== 'tel' ? (0, _input.getInputTypeByDevice)() : type;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    size: size,
    isEditing: isEditing,
    isDisabled: isDisabled
  }, isEditing ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_HBInput["default"], (0, _extends2["default"])({}, baseProps, {
    ref: inputRef,
    testId: finalTestId,
    selectOnFocus: true,
    blurOnEnterKey: true,
    onBlur: handleBlur,
    min: "0",
    onPaste: function onPaste(e) {
      // get pasted text
      var clipboardData =
      // @ts-ignore
      e.clipboardData || window.clipboardData;
      var pastedData = clipboardData.getData('Text');

      // if pasted text contains illegal data remove it
      if (!_HBMoneyInput.IS_FLOAT_REGEX.test(pastedData)) {
        pastedData = pastedData.replace(/\D/g, '');
      }
      document.execCommand('insertText', false, pastedData);
      e.preventDefault();
    },
    onChange: function onChange(e) {
      var amount = e.currentTarget.value;
      // @ts-ignore
      var addedData = e.nativeEvent.data;
      if (addedData && !_HBMoneyInput.IS_FLOAT_REGEX.test(addedData)) {
        amount = value.toString();
      }
      e.currentTarget.value = amount;
      _onChange(e);
    },
    onKeyDown: function onKeyDown(e) {
      var ctrlOn = e.ctrlKey || e.metaKey;

      // Allow special keys like backspace, delete, etc.
      if (_HBMoneyInput.ALLOWED_SPECIAL_KEYS_ON_INPUT.includes(e.key)) {
        return;
      }
      // allow only numbers, copy paste and single dot in the value
      if ((0, _HBMoneyInput.isNonNumberKey)(e, ctrlOn) || (0, _HBMoneyInput.isSecondDot)(e)) {
        e.preventDefault();
      }
    },
    type: inputType,
    inputMode: inputMode,
    step: 0.01,
    placeholder: inputPlaceholder,
    onWheel: handleBlur
  })), !isFalseyNotZero && /*#__PURE__*/_react["default"].createElement(DollarSign, {
    size: size
  }, "$")) : /*#__PURE__*/_react["default"].createElement(CurrencyContainer, {
    inputProps: baseProps,
    $isHoverable: isHoverable,
    "data-testid": finalTestId ? "".concat(finalTestId, "-currency") : undefined,
    role: "button",
    tabIndex: 0,
    onFocus: handleFocusIn,
    $isDisabled: isDisabled,
    title: String(value)
  }, isFalseyNotZero ? /*#__PURE__*/_react["default"].createElement(Placeholder, null, placeholder) : /*#__PURE__*/_react["default"].createElement(_HBCurrency["default"], {
    amount: Number(value),
    currency: currency,
    maxFractionDigits: 3,
    minFractionDigits: minFractionDigits
  })));
};
var _default = exports["default"] = HBMoneyInput; // -------------------------------- Styles -------------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBMoneyInput__Container",
  componentId: "sc-5wm10e-0"
})(["position:relative;border-radius:2px;cursor:", ";", ";", "{", ";::placeholder{font-size:", ";}}"], function (props) {
  return props.isEditing ? 'auto' : 'pointer';
}, function (props) {
  return props.isDisabled ? 'cursor: not-allowed' : '';
}, _HBInput2.Input, function (props) {
  return _HBMoneyInput.HBMONEY_INPUT_PADDING[props.size];
}, function (props) {
  return _variables.INPUT_SIZE_PROPS.system[props.size].fontSize;
});
var DollarSign = exports.DollarSign = (0, _styledComponents["default"])(_HBText["default"]).attrs({
  type: 'Body4DarkPrimary'
}).withConfig({
  displayName: "HBMoneyInput__DollarSign",
  componentId: "sc-5wm10e-1"
})(["position:absolute;top:50%;transform:translateY(-50%);margin-top:0 !important;left:", ";font-size:", ";"], function (props) {
  return _variables.INPUT_SIZE_PROPS.system[props.size].paddingLeft;
}, function (props) {
  return _variables.INPUT_SIZE_PROPS.system[props.size].fontSize;
});

/* CurrencyContainer imitates the HBInput container props */
var CurrencyContainer = exports.CurrencyContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBMoneyInput__CurrencyContainer",
  componentId: "sc-5wm10e-2"
})(["", ";", ";", ";", " user-select:none;", " ", " ", ""], function (props) {
  return (0, _HBTextField.textFieldBaseStyles)(props.inputProps);
}, function (props) {
  return _variables.INPUT_SIZE_PROPS.system[props.inputProps.size];
}, function (props) {
  return props.inputProps.readOnly && 'pointer-events: none';
}, (0, _styledIs["default"])('$isHoverable')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        ", ";\n    "])), (0, _animations.hoverTransition)('background', 'unset', _colors["default"].black_005)), _mixins.flexCenterVertical, (0, _styledIs["default"])('$isDisabled')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        border-color: ", ";\n        color: ", ";\n    "])), _colors["default"].neutral200, _colors["default"].neutral400), function (props) {
  return props.inputProps.error && "background-color: ".concat(_colors["default"].red50_15, ";\n        border: none;\n     ");
});
var Placeholder = _styledComponents["default"].div.withConfig({
  displayName: "HBMoneyInput__Placeholder",
  componentId: "sc-5wm10e-3"
})(["color:", ";"], _colors["default"].neutral600);
//# sourceMappingURL=HBMoneyInput.js.map